import { Bullets } from "./bullets";
import { Player } from "./player";
import { Maps } from "./maps";
import { Zombies } from "./zombies";
import { Waves } from "./waves";
import { Doors } from "./doors";
import { Weapons } from "./weaponPickups";
// import { Raytracing } from "./raytracing";

export class GameScene extends Phaser.Scene {
	// "bullets" all forms of projectiles basically
	delta: number;
	controlImage: Phaser.GameObjects.Image;
	gameOverText: Phaser.GameObjects.Text;
	startScene = false;
	bullets: Bullets = new Bullets();
	player: Player = new Player();
	zombies: Zombies = new Zombies();
	map: Maps = new Maps();
	waves: Waves = new Waves();
	doors: Doors = new Doors();
	pickups: Weapons = new Weapons();
	// raytracing: Raytracing = new Raytracing();

	inputKeys: KeyboardInput;
	mouseAngle: number;
	gameOver = false;
	graphics: Phaser.GameObjects.Graphics;
	newGraphics: Phaser.GameObjects.Graphics;
	loadingText: Phaser.GameObjects.Text;
	gameOverTimeout:number;

	constructor() {
		super({
			key: "GameScene"
		});
	}

	init(/*params: any*/): void {
		this.delta = 1000;
	}

	updateBar(percentage: number) {
		this.newGraphics.clear();
		this.newGraphics.fillStyle(0x3587e2, 1);
		this.newGraphics.fillRectShape(new Phaser.Geom.Rectangle(125, 205, percentage * 390, 40));

		percentage = percentage * 100;
		this.loadingText.setText("Loading: " + percentage.toFixed(2) + "%");
		console.log("P:" + percentage);
	}

	complete() {
		console.log("COMPLETE!");
		this.loadingText.destroy();
		this.graphics.destroy();
		this.newGraphics.destroy();
	}

	preload(): void {
		this.graphics = this.add.graphics();
		this.newGraphics = this.add.graphics();
		const progressBar = new Phaser.Geom.Rectangle(120, 200, 400, 50);
		const progressBarFill = new Phaser.Geom.Rectangle(125, 205, 290, 40);

		this.graphics.fillStyle(0xffffff, 1);
		this.graphics.fillRectShape(progressBar);

		this.newGraphics.fillStyle(0x3587e2, 1);
		this.newGraphics.fillRectShape(progressBarFill);

		this.loadingText = this.add.text(147, 260, "Loading: ", { fontSize: "32px", fill: "#FFF" });

		this.load.on("progress", this.updateBar, {
			newGraphics: this.newGraphics,
			loadingText: this.loadingText
		});
		this.load.on("complete", this.complete, this);
		this.player.preload(this);
		this.map.preload(this);
		this.doors.preload(this);
		this.pickups.preload(this);
		this.zombies.preload(this);
		this.bullets.preload(this);
		this.waves.preload(this);
		// this.load.image("controls", "assets/controls.png");
		this.load.multiatlas("sprites", "release_assets/packed_sprites.json", "release_assets");
	}

	create(): void {
		// The player and its settings
		this.map.create(this as any);
		this.doors.create(this, this.map);
		this.waves.create(this);
		this.pickups.create(this, this.map, this.waves);
		this.zombies.create(this, this.map, this.waves);
		this.bullets.create(this, this.zombies.self, this.map, this.doors);
		this.player.create(this, this.zombies.self, this.map, this.doors, 640, 640);
		// this.raytracing.create(this);
		const scene: this = this;

		// track the mouse angle from the player
		this.input.on(
			"pointermove",
			(pointer: Phaser.Input.Pointer): void => {
				Phaser.Math.Angle.BetweenPoints(scene.player.self, pointer);
				// const angle = Phaser.Math.Angle.Between(
				// 	this.player.self.x,
				// 	this.player.self.y,
				// 	pointer.x + this.cameras.main.scrollX,
				// 	pointer.y + this.cameras.main.scrollY
				// );
				// this.mouseAngle = Phaser.Math.RadToDeg(angle);
			},
			this
		);

		//  Input Events
		this.inputKeys = this.input.keyboard.addKeys({
			up: Phaser.Input.Keyboard.KeyCodes.W,
			down: Phaser.Input.Keyboard.KeyCodes.S,
			right: Phaser.Input.Keyboard.KeyCodes.D,
			left: Phaser.Input.Keyboard.KeyCodes.A,
			space: Phaser.Input.Keyboard.KeyCodes.SPACE,
			q: Phaser.Input.Keyboard.KeyCodes.Q
		}) as KeyboardInput;
		this.cameras.main.setSize(640, 640);
		this.cameras.main.startFollow(this.player.self);
		this.controlImage = this.add.image(640 / 2, 640 / 2, "sprites", "controls.png");
		this.controlImage.setScrollFactor(0);
		this.gameOverText = this.add.text(180, 30, "", {
			fontFamily: "Arial",
			fontSize: 24,
			color: "#FFFFFF",
			stroke: "#000000",
			strokeThickness: 1
		});
		this.gameOverText.setScrollFactor(0);
		this.gameOverText.setDepth(10);
	}

	update(time: number, delta: number): void {
		if (this.startScene) {
			if (this.player.isDead) {
				this.gameOver = true;
				// Display a game over screen...
			}
			if (this.gameOver) {
				if(this.gameOverTimeout === undefined) {
					this.gameOverTimeout = time;
				}
				// this.map.navMesh.destroy();
				if(localStorage.getItem("wave") === null) {
					localStorage.setItem("wave",this.waves.getCurrentWaveNumber().toString());
				}
				let waveHighScore: string = localStorage.getItem("wave") as string;
				if(parseInt(waveHighScore, 10) < this.waves.getCurrentWaveNumber()) {
					localStorage.setItem("wave",this.waves.getCurrentWaveNumber().toString());
				}
				waveHighScore = localStorage.getItem("wave") as string;
				this.gameOverText.setText(
					`You made it to wave: ${this.waves.getCurrentWaveNumber()}\nHigh Score: ${waveHighScore}\nClick anywhere to try again.`
				);
				// window.location.reload();
				this.map.stopBackgroundMusic();
				this.map.playDeathMusic();
				if(this.gameOverTimeout + 1000 < time) {
					if(this.input.activePointer.isDown) {
						window.location.reload();
					}
				}
				return;
			}

			this.doors.update(time, delta, this, this.player.self, this.waves);
			this.pickups.update(time, delta, this, this.player.self, this.bullets, this.waves);
			this.player.update(
				time,
				delta,
				this,
				this.inputKeys,
				this.input.activePointer,
				this.doors,
				this.waves,
				this.bullets,
				this.pickups
			);
			this.map.update(time, delta, this, this.player.self);
			this.waves.update(time, delta, this);
			this.zombies.update(time, delta, this, this.player, this.map, this.waves);
			this.bullets.update(
				time,
				delta,
				this,
				this.player.self,
				this.inputKeys,
				this.input.activePointer
			);

			// this.raytracing.update(this, this.map.collision, this.input.activePointer);
		} else {
			if (this.input.activePointer.isDown || this.inputKeys.space.isDown) {
				this.controlImage.destroy();
				this.startScene = true;
			}
		}
	}
}
